import featureImage from "../partials/feature-image";
import layoutBlocks from "../partials/layout-blocks";
import configPage from "../partials/config-page";
import seo from '../partials/seo';

function page(lang) {
    return {
        file: `site/content/contact-us/_index.${lang}.md`,
        label: `Contact Us Page ${lang}`,
        name: `contact_us_${lang}`,
        ...configPage,
        fields: [
            {label: 'Title', name: 'title', widget: 'string'},
            featureImage,
            {label: "Body", name: "body", widget: "markdown"},
            {
                name: "image",
                label: "Image",
                widget: "image",
                required: false,
                media_folder: "/site/assets/images/",
                public_folder: "/images/",
                i18n: true
            },
            {label: "Contact details active", name: "active", widget: "boolean"},
            {label: "Map Location", name: "location", widget: "map"},
            {
                label: "Contact Information",
                name: "contacts",
                widget: "object",
                fields: [
                    {
                        label: "Telephone Numbers",
                        name: "tel_list",
                        widget: "list",
                        fields: [
                            {label: "tel", name: "tel", widget: "string"},
                        ]
                    },
                    {
                        label: "Emails",
                        name: "email_list",
                        widget: "list",
                        fields: [
                            {label: "email", name: "email", widget: "string"},
                        ]
                    }
                ]
            },
            layoutBlocks(),
          ...seo
        ]
    }
}

export default page
